import { Injectable } from '@angular/core';
import { tokenNotExpired, JwtHelper, AuthConfig } from 'angular2-jwt';
import { Router } from '@angular/router';
import { AppConfig } from '../app.config';
import { LocalstorageService, HelperService, NotifyService, Constants } from '../shared/shared';
import { User } from '../schemas/schemas';
import { Http, Headers, Response } from '@angular/http';
import { ExtendedHttp } from './http/http';

import { Observable } from 'rxjs/Rx';
import 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/withLatestFrom';

@Injectable()
export class AuthService {
  private token: string = "";

  private loggedOnUser: User = null;

  constructor(private http: ExtendedHttp, private router: Router, private helperSrv: HelperService, private notfiySrv: NotifyService, private localstorageService: LocalstorageService) {
    // set token if saved in local storage
    this.token = localstorageService.retrieve(Constants.JWT_ACCESSTOKEN_NAME);
  }

  public login(user: User): any {
    return this.http.post(AppConfig.Urls.WebAPI + '/api/auth/Login', JSON.stringify(user), { headers: this.handleHeaders() })
      .map(this.handleAuthentication.bind(this)).catch((err: any) => {
        let message = this.helperSrv.ExtractErrorMessage(err);
        this.notfiySrv.TME("Fehler", message);

        return Observable.throw(err.json().error || 'backend server error');
      });
  }

  public logout(): boolean {
    // clear token remove user from local storage to log user out
    this.token = null;
    this.loggedOnUser = null;

    // Remove token from localStorage
    this.localstorageService.remove(Constants.JWT_ACCESSTOKEN_NAME);

    return true;
  }

  private handleError(error: Response | any): string {
    let errMessage = this.helperSrv.ExtractErrorMessage(error);
    return errMessage;
  }

  public handleAuthentication(response: Response): boolean {
    console.log("handleAuthentication");
    // login successful if there's a jwt token in the response
    let token = response.json();
    if (token && token.access_token) {
      let jwtHelper: JwtHelper = new JwtHelper();
      var decodedToken: any = jwtHelper.decodeToken(token.access_token);
      if (decodedToken) {
        this.loggedOnUser = new User();
        this.loggedOnUser.Username = decodedToken.unique_name;
      }

      // store username and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem(Constants.JWT_ACCESSTOKEN_NAME, token.access_token);
      localStorage.setItem(Constants.JWT_REFRESHTOKEN_NAME, token.refresh_token);
      // return true to indicate successful login
      return true;
    }
    // return false to indicate failed login
    return false;
  }

  public isAuthenticated(): boolean {
    let jwtToken = this.localstorageService.retrieve(Constants.JWT_ACCESSTOKEN_NAME);

    if (jwtToken) {
      // Check whether the id_token is expired or not
      let notExpired: boolean = tokenNotExpired(Constants.JWT_ACCESSTOKEN_NAME, jwtToken);
      if (notExpired == true) {
        return notExpired;
      }
    }
    return false;
  }

  public getUser(): User {
    if (this.loggedOnUser == null) {
      let jwtToken = this.localstorageService.retrieve(Constants.JWT_ACCESSTOKEN_NAME);
      if (jwtToken) {
        let jwtHelper: JwtHelper = new JwtHelper();
        var decodedToken: any = jwtHelper.decodeToken(jwtToken);
        this.loggedOnUser = new User();
        this.loggedOnUser.Username = decodedToken.unique_name;
      }
    }
    return this.loggedOnUser;
  }

  public hasRole(role: string): boolean {
    if (this.isAuthenticated()) {
      let jwtToken = this.localstorageService.retrieve(Constants.JWT_ACCESSTOKEN_NAME);
      if (jwtToken) {
        let token: any = JSON.parse(jwtToken);
        if (token != null && token.roles) {
          // Check whether the id_token is expired or not
          let hasRole: boolean = token.roles.indexOf(role) > -1;
          return hasRole;
        }
      }
    }
    return false;
  }

  private handleHeaders(token: string = null) {
    let getTokenHeaders = new Headers();
    getTokenHeaders.append('Access-Control-Allow-Origin', '*');
    getTokenHeaders.append('Accept', '*/*');
    if (token != null)
      getTokenHeaders.append('EmailJWT', token);
    return getTokenHeaders;
  }
}




// WEBPACK FOOTER //
// ./src/app/_authentication/auth.service.ts